export function unionState(oldArray, newArray, oldField = 'id', newField = 'id') {
	const newIds = newArray.map(newItem => newItem[newField]);
	const oldIds = oldArray.map(oldItem => oldItem[oldField]);
	const result = [];

	for (let oldItem of oldArray) {
		const index = newIds.indexOf(oldItem[oldField]);

		// If old item does not exist in new payload, just add it to result
		if (index === -1)
			result.push(oldItem);

		// Otherwise, use new version of the item
		else
			result.push(newArray.find(item => item[newField] === oldItem[oldField]));
	}
	
	// Now for new items that totally do not exist in the old array, append them to the end 
	return [
		...result,
		...newArray.filter(newItem => oldIds.indexOf(newItem[newField]) === -1)
	];
}

export function toDateTimeString(date) {
	return date.toISOString().split('T').join(' ').split('.').shift();
}
